<div class="container">
  <ng-container *ngIf="cycle$ | async as mCycle">
    <ng-container *ngIf="mCycle | option as cycle; else noCycle">
      <div class="container description" style="margin-top: 2rem; font-size: 1.25rem">
        Für <b>{{ cycle.name }} am {{ cycle.pitchDate | date: 'dd.MM.yyyy' }} </b> haben sich folgende Start-ups beworben. Bitte stimmen Sie bis spätestens
        <b>{{ cycle.votingEnd | date: 'dd.MM.yyyy' }}</b> ab, welche Start-ups Sie dort kennenlernen möchten und vergeben Sie einen Daumen hoch. Vor Ablauf des
        Abstimmungszeitraums können Sie Ihre Meinung ändern, indem Sie erneut auf den Daumen klicken.
      </div>

      <app-product-list
        [fixStatusIn]="[ProductStatus.approved]"
        [fixAnyVerdict]="true"
        [fixCycle]="cycle.uuid"
        [entryWidget]="voteWidget"
        [hideBrExport]="true"
      >
      </app-product-list>
    </ng-container>

    <ng-template #noCycle>
      <div class="container blueBox">
        <div class="no-voting-yet">Der Zeitraum der Abstimmung für die nächste Start-up Arena hat noch nicht begonnen.</div>
      </div>
    </ng-template>
  </ng-container>
</div>

<ng-template #voteWidget let-entry="entry" let-query="query">
  <app-hp-vote-widget [entry]="entry" [query]="query"></app-hp-vote-widget>
</ng-template>
